import { ChangeEventHandler, useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { Slide, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { Logo2 } from './components/new/logo2/logo2';
import ScrollToTopButton from './components/new/ScrollTop';

function App() {
  const location = useLocation();
  const { i18n } = useTranslation();
  const [navOpen, setNavOpen] = useState<boolean>(false);
  const [theme, setTheme] = useState<"light" | "dark">(window.matchMedia('(prefers-color-scheme: dark)').matches ? "dark" : "light");
  useEffect(() => {
    document.documentElement.setAttribute("theme", theme)
  }, [theme])
  useEffect(() => {
    const id = setTimeout(() => {
      if (location.hash) {
        const el = document.getElementById(location.hash.replace("#", ""));
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);

    return () => clearTimeout(id);
  }, [location.hash]);

  useEffect(() => {
    document.documentElement.setAttribute("nav-open", navOpen ? "true" : "false");
  }, [navOpen]);

  const closeNav = () => setNavOpen(false);
  const toggleNav = () => setNavOpen(!navOpen);

  const changeLang: ChangeEventHandler<HTMLInputElement> = (e) => {
    if (e.target.checked) {
      i18n.changeLanguage('en')
    } else {
      i18n.changeLanguage('pl')
    }
  }

  const changeTheme: ChangeEventHandler<HTMLInputElement> = (e) => {
    if (e.target.checked) {
      setTheme("dark");
    } else {
      setTheme("light");
    }
  }

  const prefix = location.pathname === '/' ? "#" : "/#";
  const menuItems = [
    {
      title: i18n.t("menu.services"),
      prefix,
      id: `services`,
    },
    {
      title: i18n.t("menu.about"),
      prefix,
      id: `about`,
    },
    {
      title: i18n.t("menu.realizations"),
      prefix,
      id: `realizations`,
    },
    {
      title: i18n.t("menu.contact"),
      prefix,
      id: `contact`,
      className: "contact-link"
    },
  ];

  const className = (item: typeof menuItems[number]) => ({ isActive, isPending }: { isActive: boolean, isPending: boolean }) => {
    let classNames = item.className ?? "";
    if (isPending) return classNames + " pending";
    if (!item.prefix.startsWith("#") && isActive) return classNames + " active";
    return classNames;
  };

  return (
    <div className="App">
      <ScrollToTopButton></ScrollToTopButton>
      <header>
        <Logo2 />
        <div className='burger mobile' onClick={toggleNav}></div>
        {/* <div className="desktop" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          <Switch style={{ marginRight: "1em" }} off="Light" on="Dark" checked={theme === "dark"} onChange={changeTheme}></Switch>
          <Switch off="PL" on="EN" checked={i18n.language === "en"} onChange={changeLang}></Switch>
        </div> */}
        <nav data-open={navOpen} className='main-menu underline'>
          {menuItems.map((item) => (<NavLink
            to={item.prefix + item.id}
            onClick={closeNav}
            className={className(item)}
            >{item.title}</NavLink>))}
            <a
            onClick={closeNav}
            className='close-menu-option'
            >{i18n.language === "pl" ? 'Zamknij menu' : 'Close menu'}</a>
          {/* <div className="mobile" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
            <Switch style={{ marginRight: "1em" }} off="Light" on="Dark" checked={theme === "dark"} onChange={changeTheme}></Switch>
            <Switch off="PL" on="EN" checked={i18n.language === "en"} onChange={changeLang}></Switch>
          </div> */}
        </nav>
      </header>
      <main>
        <Outlet />
      </main>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={theme}
        transition={Slide}
      />
    </div>
  );
}

export default App;
